import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	customizeSidebarMenuItemLabel: {
		id: 'navigation.global-side-navigation.customize-sidebar-menu-item.label',
		description:
			'Label on Customize button in the side navigation. Shows a modal with options to customize the sidebar.',
		defaultMessage: 'Customize sidebar',
	},
});
